module.exports = __webpack_public_path__ + "img/no-person.a9cf0184.png";